export default __webpack_public_path__ + "static/media/google-chrome.8163c630.png";